import { Box, Grid, Theme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { ApplicationProps, Groups, GroupSignatories } from '../../redux-store/types/api-types';
import { WebViewDataRow } from '../DataTable';

const headers = [
  // {
  //   header: 'Esign',
  //   valueGetter: (row: GroupSignatories) => (row.canEsign == true ? 'Yes' : 'No'),
  // },
  {
    header: 'Name*',
    label: 'name',
    valueGetter: (row: GroupSignatories) => row.name || 'N/A',
  },
  {
    header: 'PAN*',
    valueGetter: (row: GroupSignatories) => row.pan.toUpperCase() || 'N/A',
  },
  {
    header: 'Email ID*',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Mobile Number*',
    valueGetter: (row: GroupSignatories) => row.mobile ? (row.countryCode
      ? row.countryCode + '-' + row.mobile
      : row.mobile) : '-'
  },
  {
    header: 'Designation*',
    valueGetter: (row: GroupSignatories) => row.designation || 'N/A',
  },
];

export default function AuthorizedSignatories({ groups = [], application }: { groups: Groups[], application: ApplicationProps }): JSX.Element {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
          borderRadius: '10px',
          border: `1px solid ${theme.palette.grey[100]}`,
          padding: '25px',
        })}
        mt={5}
      >
        <Box>
          <Grid container >
            <Grid item xs={12}>
              <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                Authorised Signatories
              </Typography>
            </Grid>
            {groups.length === 0 && (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                {application?.applicants?.[0]?.investorType?.toLowerCase() === "soleprop" ? "No Authorised Signatories For SOLE PROPRIETOR" : "No Authorised Signatories"}
              </Grid>
            )}
            {groups.map((group, index) => {
              return (
                <React.Fragment key={group.id}>
                  <Grid container mt={2} justifyContent={'space-between'}>
                    <Grid item xs={4}>
                      <Typography>{group.name}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>
                        Total No. of required authorised signatories from this group*:{' '}
                        {group.threshold}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container pt={3}>
                    <Grid item xs={12} alignSelf="center">
                      <WebViewDataRow
                        groupIndex={index}
                        tableData={group.groupsignatories.filter(
                          (_signatory) => _signatory.isActive
                        )}
                        tableHeader={headers}
                        renderAdditionalRow={false}
                        tableHeaderCustomStyles={{
                          '.MuiTableCell-head': {
                            fontFamily: `${theme.typography.fontFamily}`,
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'text.primary',
                          },
                        }}
                        rowCustomStyles={{
                          '.MuiTableCell-root': {
                            py: '8px',
                            // overflowWrap: 'anywhere',
                            padding: { xs: '10px', sm: '10px 5px' },
                            fontFamily: `${theme.typography.fontFamily}`,
                            fontSize: 14,
                            fontWeight: 400,
                            color: 'text.primary',
                          },
                        }}
                        tableBodyCustomStyles={{
                          '.MuiTableRow-root': {
                            '&:last-child': {
                              borderBottom: 'none',
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
